import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { AnalyticsConfig } from 'uitk-react-utils';
import { UitkCardTextSegment } from 'uitk-react-cards';

import { LocalizedToggle } from 'components/common/localized-toggle';

interface PropertyDetailsSegmentProps {
  analytics?: AnalyticsConfig;
  dataStid: string;
  errorBoundaryLabel: string;
  isToggleHidden?: boolean;
  rootClassName: string;
  title: string;
  propertyInfoSection?: boolean;
  isAmenity?: boolean;
}

interface PropertyDetailsSegmentState {
  isVisible: boolean;
}

export class PropertyDetailsSegment extends React.Component<PropertyDetailsSegmentProps, PropertyDetailsSegmentState> {
  constructor(props) {
    super(props);
    this.state = { isVisible: false };
    this.toggleDisplay = this.toggleDisplay.bind(this);
  }

  private toggleDisplay() {
    this.setState(prevState => ({
      isVisible: !prevState.isVisible
    }));
  }

  public render() {
    const {
      analytics,
      children,
      dataStid,
      errorBoundaryLabel,
      isToggleHidden,
      rootClassName,
      title,
      propertyInfoSection,
      isAmenity = false
    } = this.props;
    const segmentClassName = `${rootClassName} policies__card all-cell-1-1`;
    const titleClassName = `${rootClassName}__title policies__header--primary uitk-type-heading-500 uitk-type-bold all-b-padding-two`;
    const toggleClassName = `${rootClassName}__toggle policies__toggle`;

    return (
      <ErrorBoundary label={errorBoundaryLabel}>
        {propertyInfoSection ? (
          <ComponentContent
            title={title}
            titleClassName={titleClassName}
            isToggleHidden={isToggleHidden}
            children={children}
            toggleClassName={toggleClassName}
            analytics={analytics}
            isVisible={this.state.isVisible}
            toggleDisplay={this.toggleDisplay}
            isAmenity={isAmenity}
          />
        ) : (
          <CardComponent
            segmentClassName={segmentClassName}
            dataStid={dataStid}
            title={title}
            titleClassName={titleClassName}
            isToggleHidden={isToggleHidden}
            children={children}
            toggleClassName={toggleClassName}
            analytics={analytics}
            isVisible={this.state.isVisible}
            toggleDisplay={this.toggleDisplay}
            isAmenity={isAmenity}
          />
        )}
      </ErrorBoundary>
    );
  }
}

export const CardComponent = ({
  segmentClassName,
  dataStid,
  title,
  titleClassName,
  isToggleHidden,
  children,
  toggleClassName,
  analytics,
  isVisible,
  toggleDisplay,
  isAmenity
}) => (
  <UitkCardTextSegment className={segmentClassName} data-stid={dataStid} separator={null}>
    <ComponentContent
      title={title}
      titleClassName={titleClassName}
      isToggleHidden={isToggleHidden}
      children={children}
      toggleClassName={toggleClassName}
      analytics={analytics}
      isVisible={isVisible}
      toggleDisplay={toggleDisplay}
      isAmenity={isAmenity}
    />
  </UitkCardTextSegment>
);

export const ComponentContent = ({
  title,
  titleClassName,
  isToggleHidden,
  children,
  toggleClassName,
  analytics,
  isVisible,
  toggleDisplay,
  isAmenity
}) => (
  <div className={isAmenity ? '' : 'all-y-padding-three'}>
    {title && <h3 className={titleClassName}>{title}</h3>}
    {isToggleHidden ? (
      <React.Fragment>{children}</React.Fragment>
    ) : (
      <LocalizedToggle
        className={toggleClassName}
        analytics={analytics}
        isVisible={isVisible}
        handleClick={toggleDisplay}
        collapseHeight={160}
      >
        {children}
      </LocalizedToggle>
    )}
  </div>
);
